import css from './footer.module.css'
import OIGseal from '../../oig-seal.png'
import React from 'react'

export const Footer = ({ seal, title, subtitle, children }) => {
  const imgPath = seal ? seal : OIGseal
  return (
    <footer className={css.footer} data-testid="footer">
      <section className="ds-l-container">
        <div className="ds-l-row">
          <div className="ds-l-col">
            <div className={css.content}>
              <div className={css.contentLeft}>
                <div className={css.seal} id="seal" data-testid="footer-seal">
                  <img src={imgPath} alt="" />
                  {title && (
                    <span
                      className={css.title}
                      aria-label={title}
                      data-testid="footer-title"
                    >
                      {title}
                    </span>
                  )}
                  {subtitle && (
                    <span
                      className={css.subtitle}
                      aria-label={subtitle}
                      data-testid="footer-subtitle"
                    >
                      {subtitle}
                    </span>
                  )}
                </div>
              </div>
              <div className={css.contentRight}>{children}</div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  )
}
